class RouteDeliveryManifestController {
    /*@ngInject*/
    constructor(Auth, $state, $translate, ShipmentService, CommonLayoutService) {
        this.$translate = $translate;
        this.$state = $state;
        this.Auth = Auth;
        this.ShipmentService = ShipmentService;
        this.CommonLayoutService = CommonLayoutService;
        this.printData = [];
        this.printData = undefined;
        this.loading = false;
        this.totalCoinShipment = 0;
        this.totalCashShipment = 0;
        this.coinShipmentQty = 0;
    }

    $onInit() {
        if (window.opener && window.opener.w && window.opener.w.printData) {
            this.printData = window.opener.w.printData;

            this.loading = true;
            this.ShipmentService.deliveryManifestCombined(this.printData.routeId, this.printData.routeDate)
                .then((res) => {
                    this.routeId = this.printData.routeId;
                    this.vaultDate = this.printData.routeDate;
                    this.printData = res.results;
                    this.total = res.totalAmount;

                    this.printData.forEach(shipment => {
                        if (shipment.coinFlag) {
                            this.totalCoinShipment++;
                            this.coinShipmentQty += shipment.qty;
                        }
                        else this.totalCashShipment++;
                    })

                    setTimeout(() => {
                        window.print();
                    }, 1000)
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    this.loading = false;
                })
        };
    }


    loadLocationTypeIcon = (locationType) => {
        return this.CommonLayoutService.loadLocationTypeIcon(locationType)
    }

    translateStatus(statusCode) {
        return this.$translate.instant(statusCode);
    }
}

export default RouteDeliveryManifestController;


// WEBPACK FOOTER //
// ./client/app/components/route_control/delivery_manifest_combined/delivery_manifest_combined.controller.js